<template>
  <div class="item-custom-card-header">
    <slot />
    <a-icon
      type="delete"
      theme="twoTone"
      two-tone-color="red"
      v-show="type === 'edit'"
      @click="() => deleteItem()"
    />
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: ''
    }
  },
  methods: {
    deleteItem() {
      this.$emit('deleteItem', this.item)
    }
  }
}
</script>

<style lang="less" scoped>
.item-custom-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  padding-right: 16px;
  border-top: 1px solid #d9d9d9;
  background: #f8f8f8;
  border-bottom: 1px solid #d9d9d9;
  color: #000;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  i {
    cursor: pointer;
  }
}
</style>
